import * as z from "zod";
import { selfServeOnboardingSchema } from "./get-self-serve-onboardings";

// Get full details for a single onboarding (used when sidebar opens)
export const getSelfServeOnboardingDetails = {
  name: "getSelfServeOnboardingDetails" as const,
  input: z.object({
    merchantId: z.string(),
    product: z.enum(["returns", "order-editing"]).default("returns"),
  }),
  output: selfServeOnboardingSchema,
};

export type GetSelfServeOnboardingDetailsInput = z.infer<
  typeof getSelfServeOnboardingDetails.input
>;
export type GetSelfServeOnboardingDetailsOutput = z.infer<
  typeof getSelfServeOnboardingDetails.output
>;
